import Collapsible from "@common/controls/Collapsible/component";
import DragHandle from "@common/controls/DragHandle/component";
import { HtmlTag } from "@common/controls/Html";
import { type SortableElementHOCAddedProps } from "@common/hocs/dnd";
import classnames from "classnames";
import * as React from "react";

export type AccordionItemProps = Partial<SortableElementHOCAddedProps> & {
  children?: any;
  className?: string;
  hashKey?: string;
  headingTag?: string;
  iconClassName?: string;
  index?: number;
  info?: string;
  isLazy?: boolean;
  isVisible?: boolean;
  label: any;
  noAnimation?: boolean;
  onClick?: () => void;
  titleStyle?: React.CSSProperties;
};

export type AccordionItemPropsInner = AccordionItemProps & {
  isActive?: boolean;
};

const AccordionItem = (props: AccordionItemPropsInner) => (
  <Collapsible
    ref={props.setRef}
    className={classnames("ac-item", props.className, {
      "ac-active": props.isActive,
      sortable: !!props.handleProps
    })}
    isCollapsed={!(props.isVisible ?? true)}
    style={props.style}
  >
    <div className="ac-title" onClick={props.onClick}>
      {!!props.handleProps && <DragHandle {...props.handleProps} />}

      <HtmlTag
        className="title_content"
        href={`#${props.hashKey}`}
        tag={props.hashKey ? "a" : props.headingTag ?? "h5"}
      >
        {!!props.iconClassName && <i className={props.iconClassName} />}
        {props.label}
        {!!props.info && <span className="ac-info">{props.info}</span>}
      </HtmlTag>
    </div>

    <Collapsible
      className="ac-content"
      isLazy={props.isLazy}
      isCollapsed={!props.isActive}
      noAnimation={props.noAnimation}
    >
      {props.children}
    </Collapsible>
  </Collapsible>
);
export default AccordionItem;
